import { render, staticRenderFns } from "./vencimientos.vue?vue&type=template&id=edb57352"
import script from "./vencimientos.vue?vue&type=script&lang=js"
export * from "./vencimientos.vue?vue&type=script&lang=js"
import style0 from "./vencimientos.vue?vue&type=style&index=0&id=edb57352&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports